var $cbc6af0cc98fad10$exports = {};
$cbc6af0cc98fad10$exports = {
    "breadcrumbs": `\u{30D1}\u{30F3}\u{304F}\u{305A}\u{30EA}\u{30B9}\u{30C8}`
};


export {$cbc6af0cc98fad10$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
